import type { RequestOptions } from '@@/plugin-request/request';
import type { Settings as LayoutSettings } from '@ant-design/pro-components';
import type { RequestConfig, RunTimeLayoutConfig } from '@umijs/max';
import { history } from '@umijs/max';
import React from 'react';
import logo from '../src/assets/logo.png';
import { AvatarDropdown, AvatarName, Footer } from '@/components';
import {
  clearAuthStorage,
  getAccessToken,
  getUserProfile,
} from '@/services/models/auth';

import defaultSettings from '../config/defaultSettings';
import '@ant-design/v5-patch-for-react-19';

const loginPath = '/user/login';

export async function getInitialState(): Promise<{
  settings?: Partial<LayoutSettings>;
  currentUser?: AuthModel.UserProfile;
  fetchUserInfo?: () => Promise<AuthModel.UserProfile | undefined>;
}> {
  const fetchUserInfo = async () => {
    const token = getAccessToken();
    if (!token) {
      return undefined;
    }

    const cachedProfile = getUserProfile();
    if (!cachedProfile) {
      return undefined;
    }

    return cachedProfile;
  };

  const { location } = history;
  if (location.pathname !== loginPath) {
    const currentUser = await fetchUserInfo();
    if (!currentUser) {
      history.push(loginPath);
    }
    return {
      fetchUserInfo,
      currentUser,
      settings: defaultSettings as Partial<LayoutSettings>,
    };
  }

  return {
    fetchUserInfo,
    settings: defaultSettings as Partial<LayoutSettings>,
  };
}

export const layout: RunTimeLayoutConfig = ({ initialState }) => {
  return {
      logo:()=>{return <img src={logo}></img>},
    actionsRender: false,
    avatarProps: {
      title: <AvatarName />,
      render: (_, avatarChildren) => {
        return <AvatarDropdown>{avatarChildren}</AvatarDropdown>;
      },
    },
    waterMarkProps: {
      content:
        initialState?.currentUser?.nickName ||
        initialState?.currentUser?.username,
    },
    footerRender: () => <Footer />,
    onPageChange: () => {
      const { location } = history;
      const hasUser = Boolean(initialState?.currentUser);
      if (!hasUser && location.pathname !== loginPath) {
        history.push(loginPath);
      }
    },
    menuHeaderRender: undefined,
    ...initialState?.settings,
  };
};

export const request: RequestConfig = {
//  baseURL: 'https://acci.autozooo.com',
baseURL: 'https://api.gugugogu.com',
  requestInterceptors: [
    (config: RequestOptions) => {
      const token = getAccessToken();
      return {
        ...config,
        headers: {
          ...(config.headers || {}),
          ...(token ? { Authorization: token } : {}),
        },
      };
    },
  ],
  responseInterceptors: [
    (response) => {
      const responseData = response.data as
        | {
            code?: number;
          }
        | undefined;
      if (responseData?.code === 401) {
        clearAuthStorage();
        history.push(loginPath);
      }
      return response;
    },
  ],
};
